import { Components, Theme, alpha } from "@mui/material/styles"

const Menu = (theme: Theme): Components => {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: alpha(theme.palette.secondary.main, 0.2),
          },
          "&.Mui-selected:hover": {
            backgroundColor: alpha(theme.palette.secondary.main, 0.2),
          },
        },
      },
    },
  }
}

export default Menu
